export const MinterDeployBlocks = {
  v1: 10730874,
  v2: 10784415,
  v3: 10868611,
}

export const MinterDeployBlockTimes = {
  v1: 1598375636,
  v2: 1599084275,
  v3: 1600198811,
}
